export default {
      id: "icon-lk-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "icons.svg#icon-lk",
      toString: function () {
        return this.url;
      }
    }